<!--
 * @Author: Merlin
 * @Date: 2023-12-14 19:32:59
 * @LastEditors: Merlin
 * @LastEditTime: 2025-02-06 15:58:39
 * @Description: 
-->
<template>
    <div class="toggle-tool"
        :class="{
            'toggle--switched': modelValue,
            [color]: true,
            'toggle-disabled': disabled
        }"
    >
        <label class="toggle-prelabel" v-if="preLabel">
            {{ preLabel }}
        </label>
        <div class="toggle-body" 
            @click="toSwitch"
        >
        </div>
        <label class="toggle-label" v-if="label">
            {{ label }}
        </label>
    </div>
</template>

<script>
export default defineComponent({
    name: 'toggle-tool',
});
</script>

<script setup>
const props = defineProps({
    label: String,
    preLabel: String,
    color: {
        type: String, // green
        default: 'default-color',
    },
    modelValue: {
        type: Boolean,
        required: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    }
});
const emit = defineEmits(['update:modelValue'])

function toSwitch(){
    if (props.disabled){
        return;
    }
    emit('update:modelValue', !props.modelValue);
}

</script>

<style scoped lang="scss">
.toggle-tool{
    display: flex;
    justify-content: center;
    align-items: center;
}

.toggle-tool[class~= toggle--switched]{
    .toggle-body{
        &:after{
            transform: translate(100%,-50%);
        }
    }

    &[class~=default-color]{
        .toggle-body{
            &:after{
                background-color: var(--color_blue);
            }
            &:hover{
                &:after{
                    background-color: #0b6ada;
                }
            }
        }
    }
    &[class~=green]{
        .toggle-body{
            background-color: #1bb83d;
            &:after{
                background-color: white;
            }
        }
    }
    &[class~=blue]{
        .toggle-body{
            background-color: var(--Brand-Blue-Default);
            &:after{
                background-color: white;
            }
        }
    }
}

.toggle-disabled {
    cursor: default;
    opacity: 0.5; // 原版值是 0.4 
    filter: grayscale(0.5); // 比原版多一项 
    
    .toggle-body {
        cursor: default;
        &:hover{
            &:after{
                background: var(--color_grey-20);
            }
        }
    }
    .toggle-prelabel {
        color: #3c485c;
    }
}

.toggle-body{
    background: var(--color_grey-50);
    border-radius: 10px;
    height: 20px;
    padding: 3px;
    position: relative;
    width: 34px;
    cursor: pointer;
    &:after{
        content: "";
        background-color: var(--color_grey-20);
        border-radius: 50%;
        display: block;
        height: 14px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        transition: background-color .1s ease-in-out,transform .1s ease-in-out;
        width: 14px;
    }
    &:hover{
        &:after{
            background: white;
        }
    }
}
.toggle-prelabel {
    margin-right: 6px;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
}
.toggle-label{
    margin-left: 6px;
    color: var(--color_grey-40);
    font-size: 14px;
    font-weight: 600;
}

</style>
